import React, {RefObject} from "react";
import StepsManager from "./StepsManager";
import buildResourcePath from "../../../buildResourcePath";
import store from "../../../store/configuration";
import {Step, StepItem} from "../../common/Interfaces";


interface SelfProps {
    steps: Step[],
    currentStepIndex: number,
    stepsManager: StepsManager,
    currentStepId: string,
    moveThroughStepTimeline: any
}

class StepsTitleBar extends React.Component<SelfProps> {
    stepTitleBarRef: RefObject<HTMLDivElement> = React.createRef()

    renderStepsTitleBar() {
        let singleStepWidth = (this.stepTitleBarRef.current ? this.stepTitleBarRef.current.getBoundingClientRect().width : 0) / this.props.steps.filter(s => s.available).length
        let titleBarForegroundWidth = (singleStepWidth / 2) * (this.props.currentStepIndex * 2) + 'px'
        let foregroundStyles = this.stepTitleBarRef.current ? {width: titleBarForegroundWidth} : {}
        let backgroundStyles = {
            width: `calc(100% - ${singleStepWidth}px)`
        }

        let sharedStyles = {
            marginLeft: `${singleStepWidth / 2}px`
        }

        foregroundStyles = {...foregroundStyles, ...sharedStyles}
        backgroundStyles = {...backgroundStyles, ...sharedStyles}

        let anyStepsWithIssues = this.props.stepsManager.getAll().filter(x => x.hasIssuesAsForceToChange()).length > 0
        if (anyStepsWithIssues) {
            foregroundStyles.width = "0px";
        }

        return (
            <div className="configuration-editor-steps-titlebar" ref={this.stepTitleBarRef}>
                <div className="configuration-editor-steps-titlebar-container">
                    <div className="configuration-editor-steps-titlebar-bg" style={backgroundStyles}></div>
                    <div className="configuration-editor-steps-titlebar-fg" style={foregroundStyles}></div>
                </div>

                {this.props.steps.filter(s => s.available).map((step: any, idx: number) => (
                    this.renderStepsTitleBarItem({
                        idx: idx,
                        slug: step.slug,
                        label: step.name,
                        isCompleted: this.props.currentStepIndex > idx,
                        isActive: this.props.currentStepId === step.slug,
                        isFirstStep: idx === 0,
                        isLastStep: idx === this.props.steps.filter(s => s.available).length - 1,
                        canProceedHere: step.canProceedHere
                    })
                ))}
            </div>
        )
    }

    getIssueClassNameForStep = (step: any) => {
        if (step.hasIssuesAsForceToChange()) {
            return 'force-to-change';
        }

        if (step.hasIssuesAsWarning()) {
            return 'warning';
        }

        return '';
    }

    renderStepsTitleBarItem = ({idx, slug, label, isCompleted, isActive, isFirstStep, isLastStep, canProceedHere}: StepItem) => {
        let classNames = ['configuration-editor-step']
        let bubbleClassNames = ['configuration-editor-step-bubble']
        let hasIssues = false

        if (isActive) classNames.push('configuration-editor-step--active')
        if (isFirstStep) classNames.push('first')
        if (isLastStep) classNames.push('last')

        if (isCompleted) {
            let step = this.props.stepsManager.getStepByName(slug)
            if (step) {
                if (step.hasIssues()) {
                    hasIssues = true
                    bubbleClassNames.push(this.getIssueClassNameForStep(step));
                    classNames.push('configuration-editor-step--has-issues')
                } else {
                    classNames.push('completed')
                }
            } else {
                classNames.push('completed')
            }
        }

        return (
            <div key={slug} className={classNames.join(' ')} onClick={() => {
                if (canProceedHere === undefined || canProceedHere) {
                    this.navigateToStep(slug);
                }
            }}>
                <div className={bubbleClassNames.join(' ')}>
                    {hasIssues && (
                        <span className="configuration-editor-step-error-icon">
                                <img src={buildResourcePath('/assets/icons/warning-white.svg')}/>
                            </span>
                    )}
                </div>
                <div className="configuration-editor-step-label">
                    <span className="configuration-editor-step-label-s">{window.__('Step')} {idx + 1}</span>
                    {label}
                    <span className="configuration-editor-step-label-caret"></span>
                </div>
            </div>
        )
    }

    navigateToStep = (name: string) => {
        let targetStepIdx = this.props.steps.filter(s => s.available).findIndex((x: any) => x.slug === name)
        if (targetStepIdx < 0) {
            return;
        }
        if (targetStepIdx > this.props.currentStepIndex) {
            let availableSteps = this.props.steps.filter(s => s.available)
                .map((x: any, i: any) =>
                    ({
                        index: i,
                        issues: store.issues.issues.filter((i: any) => i.field.warning.type === 0 && i.field.step.name == x.slug)
                    }))
                .filter((x: any) => x.index >= this.props.currentStepIndex && x.index <= targetStepIdx);

            for (let i = 0; i < availableSteps.length; i++) {
                let currentStep = availableSteps[i];
                let nextStep = availableSteps[i + 1];
                if (nextStep === undefined || currentStep.issues.length > 0) {
                    this.props.moveThroughStepTimeline(currentStep.index - this.props.currentStepIndex);
                    break;
                }
            }
        } else if (targetStepIdx < this.props.currentStepIndex) {
            let amount = this.props.currentStepIndex - targetStepIdx;
            this.props.moveThroughStepTimeline(-Math.abs(amount));
        }
    }


    render() {
        return this.renderStepsTitleBar();
    }
}

export default StepsTitleBar;